import React, { useContext } from "react";
import { CreatorContext } from "../../context/CreatorContext";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

function WeekCalendar({ calendarBackgroundColor, backgroundColor }) {
	const months = [
		"january",
		"february",
		"march",
		"april",
		"may",
		"june",
		"july",
		"august",
		"september",
		"october",
		"november",
		"december",
	];
	const daysOfWeek = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
	const currentDate = new Date();
	const currentDay = currentDate.getDate();
	const startDayOfMonth = new Date(
		currentDate.getFullYear(),
		currentDate.getMonth(),
		1
	).getDay();
	const { t } = useTranslation();
	const { creator } = useContext(CreatorContext);

	const calendarDays = Array.from({ length: 7 }, (_, i) => {
		const day = currentDay - (startDayOfMonth - i);
		return {
			day,
			isToday: i === startDayOfMonth,
		};
	});

	function hexToRGBA(hex, opacity) {
		let r = parseInt(hex.slice(1, 3), 16);
		let g = parseInt(hex.slice(3, 5), 16);
		let b = parseInt(hex.slice(5, 7), 16);

		return `rgba(${r}, ${g}, ${b}, ${opacity})`;
	}

	const getTextColorBasedOnBackground = (bgColor) => {
		const r = parseInt(bgColor.substring(1, 3), 16);
		const g = parseInt(bgColor.substring(3, 5), 16);
		const b = parseInt(bgColor.substring(5, 7), 16);
		const brightness = (r * 299 + g * 587 + b * 114) / 1000;
		return brightness > 128 ? "#000000" : "#FFFFFF";
	};

	return (
		<Box
			sx={{
				"& *": {
					fontFamily: creator.fontFamilyCap + "!important",
					fontSize: "9px!important",
				},
				"&.calendar": {
					fontFamily: creator.fontFamilyCap,
					textAlign: "center",
					padding: "10px 0",
				},

				"& .month": {
					fontSize: "1rem",
					color: hexToRGBA(
						getTextColorBasedOnBackground(calendarBackgroundColor || "#ffffff"),
						getTextColorBasedOnBackground(
							calendarBackgroundColor || "#ffffff"
						).toLowerCase() === "#ffffff"
							? 0.4
							: 0.6
					),
					paddingBottom: "5px",
				},

				"& .weekday": {
					fontSize: "5px!important",
					textTransform: "uppercase",
					color: hexToRGBA(
						getTextColorBasedOnBackground(calendarBackgroundColor || "#ffffff"),
						getTextColorBasedOnBackground(
							calendarBackgroundColor || "#ffffff"
						).toLowerCase() === "#ffffff"
							? 0.4
							: 0.6
					),
				},

				"& .weekdays, & .dates": {
					display: "flex",
					justifyContent: "space-between",
					padding: "0 0px",
				},

				"& .weekday, & .date": {
					padding: "0px 0",
				},

				"& .date": {
					height: "27.29px",
					width: "27.29px",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					color: hexToRGBA(
						getTextColorBasedOnBackground(calendarBackgroundColor || "#ffffff"),
						getTextColorBasedOnBackground(
							calendarBackgroundColor || "#ffffff"
						).toLowerCase() === "#ffffff"
							? 0.6
							: 0.6
					),
				},

				"& .today": {
					backgroundColor: creator.color,
					borderRadius: "50%",
					color: "white!important",
				},
				"& .today .weekday": {
					color: "white!important",
				},
			}}
			className="calendar"
		>
			<div className="month">
				{t("calendar." + months[new Date().getMonth()])}{" "}
				{new Date().getFullYear()}
			</div>
			<div className="dates">
				{calendarDays.map((date, index) => (
					<div key={index} className={date.isToday ? "date today" : "date"}>
						<div key={daysOfWeek[index]} className="weekday">
							{t("calendar." + daysOfWeek[index])}
						</div>
						{date.day}
					</div>
				))}
			</div>
			<div className="weekdays"></div>
		</Box>
	);
}

export default WeekCalendar;
